import { default as React } from 'react';
import { makeStyles, Typography, Grid } from '@material-ui/core';
import { InfoCard } from '@backstage/core-components';
import { HeaderToolbar } from './HeaderToolbar';

const useStyles = makeStyles(theme => ({
  contentRoot: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  contentContainer: {
    padding: theme.spacing(2),
  },
  noDataSourceMessage: {
    padding: theme.spacing(4),
    textAlign: 'center',
  },
}));

type NoDataSourceMessageProps = {
  timeRange: string;
  changeTimeRange: (range: string) => void;
};

export const NoDataSourceMessage: React.FC<NoDataSourceMessageProps> = ({
  timeRange,
  changeTimeRange,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.contentRoot}>
      <HeaderToolbar disabled timeRange={timeRange} changeTimeRange={changeTimeRange} />
      
      <Grid container spacing={3} className={classes.contentContainer}>
        <Grid item xs={12}>
          <InfoCard title="Principais Métricas">
            <div className={classes.noDataSourceMessage}>
              <Typography variant="body1">
                Selecione uma fonte de dados para visualizar as métricas
              </Typography>
            </div>
          </InfoCard>
        </Grid>
      </Grid>
    </div>
  );
};